export default "__VITE_ASSET__0c1c6b65__"